import ComponentsPage from './components/ComponentsPage';

const routes = [
  {
    path: '/components',
    name: 'menu.components',
    icon: 'bank',
    loginRequired: true,
    component: ComponentsPage,
    weight: 999,
    permission: [],
    children: [],
    hideOnMenu: true,
    forMobile: false,
  },
];

export default routes;
